import * as React from 'react';

export const FileInput = React.lazy(() => import('./FileInput'));
